import { Metric } from '../../../../dashboard-config/dashboard-config.model';
import {
  expandProductCatalog,
  ProductCatalogEntry,
} from '../../../_shared/dashboard-definition.model';
import { createDashboardForecastStructureDefinition } from './create-dashboard-forecast-structure-definition';
import {
  ForecastStructureMetricProfile,
  forecastStructureCompaniesCountProfile,
  forecastStructureCompaniesRevenueProfile,
  forecastStructureEconomicParticipantProfile,
  forecastStructureEmployedProfile,
} from '../forecast-metric.profile';
import { DashboardForecastStructureShell } from './dashboard-forecast-structure-shell.profile';
import { DashboardForecastStructureDefinition } from './dashboard-forecast-structure.definition';

/**
 * Product catalog for forecast structure dashboards.
 * Identity is derived in {@link createDashboardForecastStructureDefinition}.
 */

// Pending datasets: Tourism, SelfEmployed and GrossValueAdded forecasts.
type ForecastStructureMetric = Exclude<
  Metric,
  Metric.Tourism | Metric.SelfEmployed | Metric.GrossValueAdded
>;

const FORECAST_STRUCTURE_SHELLS: readonly DashboardForecastStructureShell[] = [
  'branchenstruktur',
  'teilmarktstruktur',
];

export const FORECAST_STRUCTURE_PRODUCT_CATALOG: Record<
  ForecastStructureMetric,
  ProductCatalogEntry<
    ForecastStructureMetricProfile,
    DashboardForecastStructureShell
  >
> = {
  [Metric.CompaniesCount]: {
    metric: forecastStructureCompaniesCountProfile,
    shells: FORECAST_STRUCTURE_SHELLS,
  },
  [Metric.CompaniesRevenue]: {
    metric: forecastStructureCompaniesRevenueProfile,
    shells: FORECAST_STRUCTURE_SHELLS,
  },
  [Metric.EconomicParticipant]: {
    metric: forecastStructureEconomicParticipantProfile,
    shells: FORECAST_STRUCTURE_SHELLS,
  },
  [Metric.Employed]: {
    metric: forecastStructureEmployedProfile,
    shells: FORECAST_STRUCTURE_SHELLS,
  },
};

/** All forecast structure product definitions. */
export const FORECAST_STRUCTURE_DEFINITIONS: DashboardForecastStructureDefinition[] =
  expandProductCatalog(
    Object.values(FORECAST_STRUCTURE_PRODUCT_CATALOG),
    createDashboardForecastStructureDefinition,
  );
